import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tutorials-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_tutorials_list = _resolveComponent("tutorials-list")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tooltip, { location: "bottom" }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn_icon, _mergeProps(props, {
          icon: "$oss-help",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activateHelp = !_ctx.activateHelp)),
          style: _ctx.topButtonStyle
        }), null, 16, ["style"])
      ]),
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Tutoriels", -1))
      ]),
      _: 1
    }),
    (!_ctx.isAuth() && _ctx.activateHelp)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.activateHelp = false), ["esc"])),
          onPrevious: _cache[3] || (_cache[3] = ($event: any) => (_ctx.previousStep())),
          "previous-display": ['editionTutorials', 'displayTutorial'].includes(_ctx.currentStep),
          title: "Tutoriels",
          modelValue: _ctx.activateHelp,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activateHelp) = $event)),
          "min-height": "400px",
          "min-width": "500px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_tutorials_list, {
                ref: "tutorialWizard",
                Index: "",
                starterComponents: _ctx.starterComponents,
                tutorials: _ctx.tutorials,
                onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh()))
              }, null, 8, ["starterComponents", "tutorials"])
            ])
          ]),
          _: 1
        }, 8, ["previous-display", "modelValue"]))
      : _createCommentVNode("", true)
  ]))
}